var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33019 1.154L14.4672 11.6752C14.6573 11.8709 14.8081 12.1036 14.911 12.36C15.014 12.6164 15.0669 12.8915 15.0669 13.1693C15.0669 13.447 15.014 13.7221 14.911 13.9785C14.8081 14.2349 14.6573 14.4677 14.4672 14.6633L4.33019 25.1845C4.14172 25.3817 3.91749 25.5383 3.67043 25.6451C3.42337 25.752 3.15837 25.807 2.89073 25.807C2.62309 25.807 2.3581 25.752 2.11104 25.6451C1.86398 25.5383 1.63975 25.3817 1.45127 25.1845C1.26125 24.9889 1.11042 24.7562 1.00749 24.4997C0.90456 24.2433 0.851567 23.9683 0.851567 23.6905C0.851567 23.4127 0.90456 23.1377 1.00749 22.8813C1.11042 22.6248 1.26125 22.3921 1.45127 22.1965L8.62891 13.1693L1.45127 4.14203C1.0695 3.74579 0.855024 3.20838 0.855024 2.64801C0.855024 2.37055 0.907678 2.0958 1.00998 1.83946C1.11229 1.58312 1.26223 1.3502 1.45127 1.154C1.83304 0.75776 2.35083 0.535156 2.89073 0.535156C3.15806 0.535156 3.42278 0.589807 3.66976 0.695988C3.91674 0.802169 4.14116 0.957801 4.33019 1.154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4b361152b6b13414fccd0c65b285686d.svg";
export { ForwardRef as ReactComponent };